import getType from"./getType";export function isString(payload){return getType(payload)==="String"}export default isString;